import request from '@/utils/request'
import { NoticeCenter } from './type'
import {
  ParamsGetMessageNotificationCount,
  ResponseGetMessageNotificationCount,
  ParamsGetMessageNotificationList,
  ResponseGetMessageNotificationList,
  ParamsMarkMessageNotificationRead
} from './model'

/**
 * @description 消息中心 - 获取指定类型的消息列表
 * @author 陶银辉
 */
export function getNoticeList(data: NoticeCenter.GetListParams): Promise<NoticeCenter.GetListRes> {
  return request.post({
    url: '/noticeCenter/getNoticeList',
    data
  })
}

/**
 * @description 消息中心 - 清除指定消息
 * @author 陶银辉
 */
export function updateNoticeStatus(data: NoticeCenter.UpdateNoticeStatusParams): Promise<void> {
  return request.post({
    url: '/noticeCenter/updateNoticeStatus',
    data
  })
}

/**
 * @description 消息中心 - 获取未读总数
 * @author 陶银辉
 */
export function getNoticeCount(): Promise<number> {
  return request.post({
    url: '/noticeCenter/getNoticeCount'
  })
}

/**
 * @author 杨道允
 * @description 消息中心-通知列表-账单确认 */
export function getBillConfirmNoticeList(data: NoticeCenter.GetListParams) {
  return request.post<NoticeCenter.BillConfirmNoticeRes>(
    {
      url: '/web/notice/getNoticeList/scw3100',
      data
    },
    {
      apiUrl: 'scw-leyo'
    }
  )
}

/**
 * @author 杨道允
 * @description 消息中心-通知数量-账单确认 */
export function getBillConfirmNoticeCount() {
  return request.post<number>(
    {
      url: '/web/notice/getNoticeCount/scw3100'
    },
    {
      apiUrl: 'scw-leyo'
    }
  )
}

/** 消息通知-未读汇总 */
export function getMessageNotificationCount(
  params: ParamsGetMessageNotificationCount
): Promise<ResponseGetMessageNotificationCount> {
  return request.post({
    url: '/srmNotice/getUnreadSummary',
    params
  })
}

/** 消息通知-列表 */
export function getMessageNotificationList(
  params: ParamsGetMessageNotificationList
): Promise<ResponseGetMessageNotificationList> {
  return request.post({
    url: '/srmNotice/getNoticeList',
    params
  })
}

/** 消息通知-标记已读 */
export function markMessageNotificationRead(
  params: ParamsMarkMessageNotificationRead
): Promise<void> {
  return request.post({
    url: '/srmNotice/markRead',
    params
  })
}
